module.exports = __webpack_public_path__ + "static/img/tips.5f79f9c.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/tips.png
// module id = 2591
// module chunks = 0